import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleFieldGetAllService } from '../../services';

export const fetchModuleFieldGetAll = createAsyncThunk(
    'moduleFieldGetAll/fetchModuleFieldGetAll',
    async () => {
        const response = await ModuleFieldGetAllService()
        return response.result;
    }
);

const moduleFieldGetAllSlice = createSlice({
    name: 'moduleFieldGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleFieldGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleFieldGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleFieldGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleFieldGetAllSlice.reducer;
